import Axios from 'axios'
import formatter from '@/core/utils/formatter'

const buildPessoaParams = params => ({
  nome: params.nome,
  cpf: formatter.extractOnlyNumbers(params.cpf),
  rg: formatter.extractOnlyNumbers(params.rg),
  dt_nascimento: formatter.formatDate(params.dt_nascimento),
  sexo: params.sexo,
})

const buildPresencialParams = params => ({
  pessoa: buildPessoaParams(params.pessoa),
  agendamento: {
    dt_agendamento: params.agendamento.dt_agendamento ? formatter.formatDate(params.agendamento.dt_agendamento) : null,
    id_clinica: params.agendamento.clinica.id_clinica,
  },
  funcao: params.funcao.id_funcao,
  setor: params.setor.id_setor,
})

const buildTelemedicinaParams = params => ({
  pessoa: buildPessoaParams(params.pessoa),
  agendamento: { online: true, id_horario: params.agendamento.id_horario },
  funcao: params.funcao.id_funcao,
  setor: params.setor.id_setor,
  uploads: params.uploads,
})

export default {
  save: (params, exameOnline = false) => {
    const data = exameOnline ? buildTelemedicinaParams(params) : buildPresencialParams(params)

    const { id_funcionario, exame } = params.agendamento

    return Axios.post(`/funcionarios/${id_funcionario}/aso/${exame}`, data)
  },
  update: aso => {
    return Axios.put(`/asos/${aso.idAso}`, aso)
  },
  getAsos: (page, perPage, filtros, options, ged, dtInicial, dtFinal, extraParams = {}) => {
    const filtroParams = {}
    filtros.forEach(filtro => (filtroParams[filtro.column] = filtro.value))

    if (dtInicial && dtFinal) {
      filtroParams.date = JSON.stringify({
        initialDate: dtInicial,
        finalDate: dtFinal,
      })
    }

    let { sortDesc, sortBy } = options
    const [firstSortBy] = sortBy
    if (firstSortBy) {
      sortBy = firstSortBy
    } else if (ged) {
      sortBy = ['id_aso', 'status_digitalizacao']
    } else {
      sortBy = 'id_aso'
    }

    sortDesc = sortDesc[0] ? 'desc' : 'asc'

    const { itemsPerPage } = options
    perPage = itemsPerPage

    return Axios.get('/asos', {
      params: { page, perPage, sortBy, order: sortDesc, ...filtroParams, ged, ...extraParams },
    })
  },
  openAso: idAso => Axios.get(`/asos/${idAso}/arquivo-retorno/download`),
  openFichaClinica: idAso => Axios.get(`/asos/download-ficha-clinica/${idAso}`),
  getAso: idAso => Axios.get(`/asos/${idAso}`),
  getExames: idAso => Axios.get(`/asos/${idAso}/exames`),
  getPendenciasValidacao: idAso => Axios.get(`/asos/${idAso}/pendencias-validacao`),
  cancelarAso: idAso => Axios.patch(`/asos/${idAso}/cancelar`),
  ativarAso: idAso => Axios.patch(`/asos/${idAso}/ativar`),
  reenviarEmailClinica: idAso => Axios.post(`/asos/${idAso}/reenviar-email-clinica`),
  getResultadosAso: idAso => Axios.get(`/asos/${idAso}/resultados`),
  getExameDigitalizacao: idAso => Axios.get(`/asos/${idAso}/exame-digitalizacao`),
  corrigirDigitalizacao: (idAso, data) => Axios.post(`/asos/${idAso}/exame-digitalizacao/corrigir`, data),
  desmembrarDigitalizacao: (idAso, data) => Axios.post(`/asos/${idAso}/exame-digitalizacao/desmembrar`, data),
  salvarDadosDigitalizacao: (idAso, payload) => Axios.put(`/asos/${idAso}/exame-digitalizacao/dados`, { payload }),
  buscarDadosSocPorCodigoSequencial: codigoSequencial =>
    Axios.get(`/asos/soc/codigo-sequencial/${codigoSequencial}`),
  onBulkInativar: idsAsos => Axios.patch('/asos/inativar-massa', { idsAsos }),
  onBulkAtivar: idsAsos => Axios.patch('/asos/ativar-massa', { idsAsos }),
  onBulkNaoCompareceu: idsAsos => Axios.patch('/asos/nao-compareceu', { idsAsos }),
  onBulkCancelarFinalizacao: idsAsos => Axios.patch('/asos/cancelar-finalizacao', { idsAsos }),
  reverterCancelarFinalizacao: idAso => Axios.patch(`/asos/${idAso}/reverter-cancelar-finalizacao`),
  getProtocoloAso: idAso => Axios.get(`/asos/${idAso}/protocolo`),
  requestProtocoloZip: payload => Axios.post('/asos/protocolo/request-zip', payload),
  requestBulkProtocoloZip: payload => Axios.post('/asos/protocolo/request-bulk-zip', payload),
  downloadProtocoloZip: fileName =>
    Axios.get(`/asos/protocolo/download-zip/${fileName}`, {
      responseType: 'blob',
    }),
}
